/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { IPlace } from "../../functions/src/api/placeInterface";
import { Logger } from "../utils/logger";

interface IProps {
    defaultValue?: string | undefined;
    onPlaceChanged: (place: IPlace | undefined) => void;
}

export class PlaceInput extends React.PureComponent<IProps, {}> {
    private readonly inputRef = React.createRef<HTMLInputElement>();

    public render() {
        const { defaultValue } = this.props;
        return (
            <input
                defaultValue={defaultValue}
                ref={this.inputRef}
                type="text"
            />
        );
    }

    public componentDidMount() {
        const autocomplete = new google.maps.places.Autocomplete(this.inputRef.current!, {
            componentRestrictions: { country: "us" },
            types: [ "address" ],
        });
        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();

            if (place == null) {
                this.handlePlaceChanged(undefined);
                return;
            }

            const { address_components } = place;
            if (address_components == null) {
                this.handlePlaceChanged(undefined);
                Logger.error("Place is missing `address_components`.");
                return;
            }

            const { types } = place;
            if (types == null) {
                Logger.error("Place is missing `types`. Likely not a residence.");

                if (place.types.find(value => value === "premise" || value === "subpremise")) {
                    this.handlePlaceChanged(undefined);
                    Logger.error("Place is likely not a residence.");
                    return;
                }
            }

            this.handlePlaceChanged(place);
        });
    }

    private handlePlaceChanged = (place: IPlace | undefined) => {
        const { onPlaceChanged } = this.props;
        onPlaceChanged(place);
    };
}
